import { useStepsStore } from '../../stores/StepsStore';

export const RegistrationActions = (props: { loading: boolean; handleNext: () => void; handlePrevious: () => void; }) => {
    const { currentStep } = useStepsStore();

    return <div className={currentStep === 'final' ? "button-group final-step" : "button-group" }>
        {['verifyOrder', 'showOrder', 'ncf_userDetails', 'ncf_medicalDetails', 'ncf_emergency', 'billing_details', 'vat_details', 'gcl'].includes(currentStep) ? <button className="nav-button previous-button" onClick={props.handlePrevious}>
            Previous
        </button> : ''}
        {!props.loading ? <button className="nav-button next-button" onClick={props.handleNext}>
            {currentStep === 'after_gcl' ? 'Confirm Now' : (currentStep === 'final' ? 'Complete New Customer Form' : (currentStep === 'gcl' ? 'Pay in GoCardless' : 'Next'))}
        </button> : ''}
        {props.loading ? <button className="loading-button loading" disabled>
            <span className="spinner"></span>
            {currentStep === 'gcl' ? 'Verifying account ...' : ''}
            {currentStep === 'deviceId' ? 'Retrieving order ...' : ''}
            {currentStep === 'verifyOrder' ? 'Verifying order ...' : ''}
            {currentStep === 'showOrder' ? 'Registering ...' : ''}
            {currentStep === 'after_gcl' ? 'Saving ...' : ''}
        </button> : ''}
    </div>;
}